var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgActiveEmergenciesIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.51652 2.93344L1.19079 17.353C1.0404 17.6134 0.961209 17.9088 0.961182 18.2095C0.961154 18.5102 1.04029 18.8056 1.19063 19.066C1.34098 19.3264 1.55723 19.5427 1.81765 19.6931C2.07808 19.8434 2.37349 19.9225 2.67419 19.9225H19.3243C19.625 19.9225 19.9204 19.8434 20.1809 19.6931C20.4413 19.5427 20.6575 19.3264 20.8079 19.066C20.9582 18.8056 21.0374 18.5102 21.0373 18.2095C21.0373 17.9088 20.9581 17.6134 20.8077 17.353L12.4829 2.93344C12.3326 2.67309 12.1164 2.4569 11.856 2.30659C11.5957 2.15628 11.3003 2.07715 10.9997 2.07715C10.6991 2.07715 10.4037 2.15628 10.1434 2.30659C9.88304 2.4569 9.66684 2.67309 9.51652 2.93344Z",
    fill: "#E54C4C"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.1077 7.38086H10.8905C10.3558 7.38086 9.92236 7.81432 9.92236 8.34901V12.9766C9.92236 13.5113 10.3558 13.9448 10.8905 13.9448H11.1077C11.6424 13.9448 12.0759 13.5113 12.0759 12.9766V8.34901C12.0759 7.81432 11.6424 7.38086 11.1077 7.38086Z",
    fill: "#FFF7ED"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10.9991 17.6149C11.5938 17.6149 12.0759 17.1328 12.0759 16.5382C12.0759 15.9435 11.5938 15.4614 10.9991 15.4614C10.4044 15.4614 9.92236 15.9435 9.92236 16.5382C9.92236 17.1328 10.4044 17.6149 10.9991 17.6149Z",
    fill: "#FFF7ED"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgActiveEmergenciesIcon);
export default __webpack_public_path__ + "static/media/activeEmergenciesIcon.098fc9524a4ee34821f594dbdfd3c870.svg";
export { ForwardRef as ReactComponent };